import { TAlertType } from 'domain/globalAlerts/types';

type TAlertPalette = { background: string; foreground: string };

export const ALERT_PALETTE: Record<TAlertType, TAlertPalette> = {
  info: { background: '#eff6ff', foreground: '#1e40af' },
  success: { background: '#edf7ed', foreground: '#166534' },
  warning: { background: '#fff4e5', foreground: '#854d0e' },
  danger: { background: '#fdeded', foreground: '#991b1b' },
  neutral: { background: '#f9fafb', foreground: '#1f2937' },
};

export const paletteFor = (variant: TAlertType): TAlertPalette =>
  ALERT_PALETTE[variant] ?? ALERT_PALETTE.neutral;
